const SET_REVIEW_SESSION_TITLE = "SET_REVIEW_SESSION_TITLE";

// Define reducer function
const reviewReducer = (state = { reviewSessionTitle: "" }, action) => {
  switch (action.type) {
    case SET_REVIEW_SESSION_TITLE:
      return {
        ...state,
        reviewSessionTitle: action.payload.reviewSessionTitle,
      };
    default:
      return state;
  }
};

const setReviewSessionTitle = (reviewSessionTitle) => ({
  type: SET_REVIEW_SESSION_TITLE,
  payload: { reviewSessionTitle },
});

export { setReviewSessionTitle };
export default reviewReducer;
